export const CONTENTFUL_COACH_PROFILE_PAGE_ENTRY_ID = '2nkefJr83aL5INnotb8xPy'
export const CONTENTFUL_COACH_PROFILE_PAGE_ENTRY_ID_EXPERIMENT =
  '3r5dHauridjJlMicTcRoqo'
export const CONTENTFUL_COACH_PROFILE_PAGE_ENTRY_ID_FREE_CONSULT =
  '78wNUZC4ii44D9FLqSW81I'
export const CONTENTFUL_HOMEPAGE_SIGNUP_SURVEY_ENTRY_ID =
  '5CbnmkQ2dy0eNvJs0r7oNU'
export const CONTENTFUL_SURVEY_ID = 3
